import { APIImageType } from '@types';

/**
 * Checks if the given src contains a valid image source.
 * Only checks the first element if `src` is an array.
 *
 * @param src - The image source(s) of type APIImageType | APIImageType[] | undefined
 * @returns {boolean} - True if a valid image source exists, false otherwise
 */
export function validateImage(src: APIImageType | APIImageType[] | undefined): boolean {
  if (!src) return false; // Check if src is undefined or null

  const firstImage = Array.isArray(src) ? src[0] : src;

  // Validate the firstImage as a single APIImageType
  return isValidImage(firstImage);
}

/**
 * Helper function to check if a single APIImageType has a valid source.
 *
 * @param singleSrc - A single APIImageType to validate
 * @returns {boolean} - True if a valid image source exists
 */
function isValidImage(singleSrc: APIImageType): boolean {
  // If it's an object, check if it has a non-empty `url` (ImageWithMetadata)
  if (
    typeof singleSrc === 'object' &&
    singleSrc !== null &&
    'url' in singleSrc &&
    typeof singleSrc.url === 'string' &&
    singleSrc.url.trim() !== ''
  ) {
    return true;
  }

  return false;
}
